import $ from 'jquery';
import empty from './utils/empty';

class Notes {
    constructor () {
        this.$document = $(document);
        this.$body = $('body');
        this.$noteContainer = $('.js-notes');
        this.$notes = $('.js-notes__note');
        this.$overlay = $('.js-chapter-overlay');
        //SBTODO: Update to js-class
        this.$closeButton = $('.c-notes__close');
        this.$links = $('.js-note-marker');

        this.$links.on('click', $.proxy(this.openNoteContainer, this));
        this.$closeButton.on('click', $.proxy(this.closeNoteContainer, this));
        this.$overlay.on('click', $.proxy(this.closeNoteContainer, this));

        this.$document.keyup((e) => {
            // Escape Key
            if (e.keyCode === 27) {
                if (this.$noteContainer.hasClass('is-visible')) {
                    this.closeNoteContainer();
                }
            }
        });
    }

    openNoteContainer (e) {
        this.$noteContainer.addClass('is-visible');
        this.$body.addClass('notes-open');

        const $elem = $(e.currentTarget);

        if ($elem !== undefined) {
            const href = $elem.attr('href');

            if (href) {
                const noteHash = href.toString().replace('#', '');
                this.showNote(noteHash);
            }
        }
    }

    showNote (noteHash) {
        const $note = this.$notes.filter((index) => {
            return this.$notes.eq(index).data('reference') === noteHash;
        });

        if ($note !== undefined && $note.length) {
            const number = $note.data('number');
            $note.prepend(`<small>${number}.</small>`).addClass('is-visible');
        }
    }

    hideNote () {
        this.$notes.removeClass('is-visible');
        this.$notes.find('small').remove();
    }

    closeNoteContainer (e) {
        this.hideNote();
        this.$body.removeClass('notes-open');
        this.$noteContainer.removeClass('is-visible');
    }
}

export default Notes;
